import { DailyStartVolume } from './daily_start_volume';
import { DailyStartDayLesson } from './daily_start_day_lesson';
export class DailyStartDay {
    constructor(data, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dailyStartVolumeId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "day", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalDuration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isCurrent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isCompleted", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isSkipped", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "completedCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dailyStartVolume", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dailyStartDayLesson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.dailyStartVolumeId = data.dailyStartVolumeId;
        this.day = data.day;
        this.totalDuration = data.totalDuration;
        this.isCurrent = data.isCurrent;
        this.isCompleted = data.isCompleted;
        this.isSkipped = data.isSkipped;
        this.completedCount = data.completedCount;
        this.dailyStartVolume = data.dailyStartVolume ? new DailyStartVolume(data.dailyStartVolume, config) : null;
        this.dailyStartDayLesson = data.dailyStartDayLesson
            ? new DailyStartDayLesson(data.dailyStartDayLesson, config)
            : null;
    }
    get hasCompleted() {
        return this.completedCount >= 1;
    }
}
